module.exports = __webpack_public_path__ + "static/zuri-dd3e9e072e5d33c8975ef6410a60fc1b.png";